if (!customElements.get("m-announcement-bar")) {
  class MAnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider) return;
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const direction = this.dataset.sliderDirection || "horizontal";
      const transitionSpeed = parseInt(this.dataset.transitionSpeed) || 500; // Capturando a nova velocidade
      
      const slideContainer = this.querySelector(".swiper-container");
      
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          direction: direction,
          slidesPerView: 1,
          slidesPerGroup: 1,
          speed: transitionSpeed, // Aplicando a velocidade da animação
          autoHeight: direction === 'horizontal',
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
                disableOnInteraction: false,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
        });
      }
    }
  }

  customElements.define("m-announcement-bar", MAnnouncementBar);
}